import ActionTypes from "../constants/ActionTypes";
import API from "../api/";
import _ from "lodash";

const fetchClubsRequest = () => ({
    type: ActionTypes.FETCH_CLUBS_REQUEST,
});

const fetchClubsSuccess = clubs => ({
    type: ActionTypes.FETCH_CLUBS_SUCCESS,
    clubs,
});

const fetchClubsFail = error => ({
    type: ActionTypes.FETCH_CLUBS_FAIL,
    error,
});

export const fetchClubs = () => (dispatch, getState) => {
    const clubs = getState().clubs.clubs;
    if (!_.isEmpty(clubs)) {
        return Promise.resolve();
    }
    dispatch(fetchClubsRequest());
    return API.fetchClubs()
        .then(data => {
            dispatch(fetchClubsSuccess(data));
            return data;
        })
        .catch(error => {
            dispatch(fetchClubsFail(error));
            throw error;
        });
};
